class QuizCheckout {
  constructor() {
    this.body = document.body;
    this.filterd_step_2 = [];
    this.blends_found = [];
    this.init();
  }
  init() {
  	this.fetchQuizData(this);
  }
  fetchQuizData(that){
  	fetch(tayst.getQuizData, {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: ""
    }).then(response => response.text())
    .then(data => {
      if(!cn(data)){
        data = JSON.parse(data);
        if(data.status == 0){
          let quiz_data = data.data;
          if(quiz_data.length > 0){
            that.dataEvent(quiz_data,that);
            document.querySelector(".qmitems-summary-checkout").removeAttribute("disabled");
          }
        }else{
          alert(data.msg);
        }
        // that.hideLoader();
      }
		})
  }
  dataEvent(quiz_data,that){
    document.addEventListener("click", async function(e) {
      if(e.target.closest(".quiz-banner .qbanner-btn")){
        let close_par = e.target.closest(".quiz-banner");
        let data_stepname = e.target.getAttribute("data-stepname");
        close_par.classList.add("hidden");
        close_par.classList.remove("show");
        
        document.querySelectorAll(".quiz-steps")[0].classList.remove("hidden");
        setTimeout(() => {
          document.querySelectorAll(".quiz-steps")[0].classList.add("show");
          window.scrollTo({
            top: document.querySelectorAll(".quiz-steps")[0].getBoundingClientRect().top + window.scrollY - 100,
            behavior: "smooth",
          });
          that.updateProgressBar(that);
          gtag('event', 'quiz_step', {
            step_name: data_stepname
          });
        }, 200);
      }
      if(e.target.closest(".quiz-steps .qsteps-content")){
        const stepContent = e.target.closest(".quiz-steps .qsteps-content");
        if (!stepContent) return;
        const curr_par = stepContent.closest(".quiz-steps");
        curr_par.querySelectorAll(".qsteps-content").forEach(s => s.classList.remove("active"));
        stepContent.classList.add("active");
        const next_step = that.getNextElement(curr_par, document.querySelectorAll(".quiz-steps"), quiz_data, that);
        setTimeout(() => {
          curr_par.classList.add("hidden");
          curr_par.classList.remove("show");
          next_step.classList.remove("hidden");
        }, 500);
        setTimeout(() => {
          next_step.classList.add("show");
          window.scrollTo({
            top: next_step.getBoundingClientRect().top + window.scrollY - 100,
            behavior: "smooth",
          });
          that.updateProgressBar(that);
          let data_stepname = curr_par.getAttribute("data-type");
          let data_stepvalue = stepContent.getAttribute("data-name");
          gtag('event', 'quiz_step', {
            step_name: data_stepname,
            step_value: data_stepvalue
          });
        }, 550);
      }
      if(e.target.closest(".qpselect-content-wrap .qpselect-content")){
        let curr_par = e.target.closest(".qpselect-content");
        document.querySelectorAll(".qpselect-content-wrap .qpselect-content").forEach(function(item,i){
          item.classList.remove("active");
        });
        that.showLoader(false,true);
        curr_par.classList.add("active");
        let data_cups = curr_par.getAttribute("data-cups");
        if(that.filterd_step_2.length > 0){
          that.blends_found.length = 0;
          for(let i=0;i<that.filterd_step_2.length;i++){
            if(data_cups == that.filterd_step_2[i].cups_option){
              that.blends_found.push(that.filterd_step_2[i]);
            }
          }
          if(that.blends_found.length > 0){
            let match_items_par = document.querySelector(".quiz-matching-items");
            let is_drip = that.blends_found[0].machine_name.toLowerCase();
            if(!cn(match_items_par.querySelector(".qmitems-impact-label-pods")?.innerHTML)){
              if(is_drip.includes("drip")){
                match_items_par.querySelector(".qmitems-impact-label").innerHTML = match_items_par.querySelector(".qmitems-impact-label-ground").innerHTML;
                if(!that.blends_found[0].coffee_type.toLowerCase().includes("ground")){
                  match_items_par.querySelector(".qmitems-impact-label").innerHTML = match_items_par.querySelector(".qmitems-impact-label-wholebean").innerHTML;
                }
              }else if(is_drip.includes("nespresso")){
                match_items_par.querySelector(".qmitems-impact-label").innerHTML = match_items_par.querySelector(".qmitems-impact-label-nespresso").innerHTML;
              }else{
                match_items_par.querySelector(".qmitems-impact-label").innerHTML = match_items_par.querySelector(".qmitems-impact-label-pods").innerHTML;
              }
            }
            let items_json_url = "/collections/all-blends?view=quiz-items-meta";
            fetch(items_json_url).then(response => response.text())
            .then(async json_data => {
              if(!cn(json_data)){
                json_data = JSON.parse(json_data);
                let final_variants = that.blends_found.map(a1 => {
                  const match = json_data.find(a2 => a2.pid === a1.pid);
                  if (match) {
                    return {...a1, ...match};
                  }
                  return a1;
                });
                const recom_parent = document.querySelector('.qmitems-recom-items .qmitems-recom-items-inner');
                let machine_type = that.blends_found[0].machine_name.toLowerCase();
                let fill_val = "Cups";
                if(machine_type.includes("drip")){
                  if(that.blends_found[0].coffee_type.toLowerCase().includes("ground")){
                    fill_val = "Bags";
                  }else{
                    fill_val = "Bags";
                  }
                }
                let items_box = 1;
                if(fill_val.includes("Cups")){
                  items_box = 10;
                }
                recom_parent.innerHTML = "";
                recom_parent.innerHTML = final_variants.filter(v => v.product_title != undefined).map((v,i) => `
                  <div class="qmitems-recom-item flex" data-plan="${v.selling_plan}" data-planrequire="${v.subscription_only}" 
                  data-off="${v.discount_off}" data-var="${v.item_variant_id}" data-qty="${v.item_qty}" data-type="${v.product_target}">
                    <div class="qmitems-content-left">
                      <div class="qmitems-recom-item-image-wrap">
                        <div class="responsive-image-wrapper">
                          <img loading="lazy" class="theme-img js"
                          alt="${v.image_alt}" width="120" height="120"
                          srcset="${v.image} 150w, ${v.image} 140w, ${v.image} 210w"
                          sizes="(max-width: 1023px) calc((100vw - 100px) / 3), (max-width: 1680px) calc((100vw - 120px) / 4), 400px" src="${v.image}"/>
                        </div>
                      </div>
                    </div>
                    <div class="qmitems-content-right flex">
                      <h4 class="h6 qmitems-recom-item-title">${v.product_title}</h4>
                      <p class="qmitems-recom-item-label">${items_box*v.item_qty} ${fill_val}</p>
                      <div class="qmitems-recom-item-descr"><div class="descr">${that.decodeHTML(v.description)}</div></div>
                    </div>
                  </div>
                `).join('');
                document.querySelectorAll(".qmitems-recom-item-descr").forEach(function(item) {
                  const textEl = item.querySelector(".descr");
                  const fullText = textEl.innerHTML.trim();
                  const limit = 65;
                  if (fullText.length <= limit) return;
                  const shortText = fullText.substring(0, limit);
                  const moreBtn = document.createElement("span");
                  moreBtn.className = "qmitems-recom-item-descr-toggle";
                  textEl.innerHTML = shortText+"...";
                  moreBtn.textContent = "Show more";
                  textEl.appendChild(moreBtn);
                  let expanded = false;
                  moreBtn.addEventListener("click", function() {
                    expanded = !expanded;
                    if (expanded) {
                      textEl.innerHTML = fullText;
                      moreBtn.textContent = "Show less";
                    } else {
                      textEl.innerHTML = shortText+"...";
                      moreBtn.textContent = "Show more";
                    }
                    textEl.appendChild(moreBtn);
                  });
                });
                let map_prod_type = final_variants[0].product_target;
                let recom_item_imgs = match_items_par.querySelectorAll(".qmitems-recom-item-img");
                if(recom_item_imgs.length > 0){
                  for(let i=0;i<recom_item_imgs.length;i++){
                    let img_type = recom_item_imgs[i].getAttribute("data-type");
                    if(map_prod_type == img_type){
                      recom_item_imgs[i].classList.remove("hide");
                      recom_item_imgs[i].classList.add("active");
                    }else{
                      recom_item_imgs[i].classList.add("hide");
                      recom_item_imgs[i].classList.remove("active");
                    }
                  }
                }
                let recom_item_freq = match_items_par.querySelector(".qmitems-recom-item-delivery");
                recom_item_freq.querySelector("span").textContent = final_variants[0].selling_plan_default_frequency;
                recom_item_freq.querySelector(".qmitems-recom-item-type").textContent = final_variants[0].product_target;
                let recom_item_title = match_items_par.querySelector(".qmitems-recom-item-img.active .qmitems-recom-item-img-title");
                let recom_subheading = match_items_par.querySelector(".qmitems-titles-wrap .qmitems-recom-subtitle");
                if(!cn(recom_item_title)){
                  let recom_item_title_copy = recom_item_title.getAttribute("data-title");
                  recom_item_title.textContent = recom_item_title_copy.replace("{amount}",final_variants[0].cups_option);
                }
                if(recom_subheading){
                  let recom_subheading_text = recom_subheading.textContent;
                  recom_subheading.textContent = recom_subheading.textContent.replace("{cups}",final_variants[0].cups_option+" "+fill_val);
                  recom_subheading.textContent = recom_subheading.textContent.replace("{machine_name}",final_variants[0].machine_name);
                }
                let quiz_total = 0;
                let quiz_subtotal = 0;
                final_variants.filter(v => v.product_title != undefined).forEach(function(e,i){
                  let item_price = parseFloat(e.item_price);
                  let actual_price = e.item_price;
                  if(e.discount_off != "" && e.discount_off != undefined){
                    let discount_off = parseFloat(e.discount_off);
                    item_price = e.item_price * (1 - discount_off / 100);
                    item_price = item_price.toFixed(2);
                  }
                  let item_qty = parseInt(e.item_qty);
                  quiz_subtotal = quiz_subtotal + (actual_price * item_qty * 100);
                  quiz_total = quiz_total + (item_price * item_qty * 100);
                });
                let active_machine = machine_type;
                active_machine = active_machine.toLowerCase().replace(/\s+/g, "-");
                if(active_machine == "drip"){
                  active_machine = that.blends_found[0].coffee_type.toLowerCase().replace(/\s+/g, "-");
                }
                let target_bundle = ".bundle-product[data-name="+active_machine+"]";
                let bundle_id = document.querySelector(target_bundle).value;
                let bundle_configuration = await recharge.bundleData.loadBundleData(bundle_id);
                let bundle_discount = bundle_configuration.selling_plan_groups[0]?.selling_plans[0]?.price_adjustments[0]?.value;
                let discount_value = bundle_discount;
                if(bundle_discount){
                  bundle_discount = quiz_subtotal * discount_value / 100;
                }
                let free_item_par = document.querySelector(".qmitems-summary-free-item-value");
                let free_item_val = 0;
                if(free_item_par){
                  free_item_val = free_item_par.getAttribute("data-value") * 1;
                }
                let subtotal = quiz_subtotal + free_item_val;
                document.querySelector(".qmitems-order-summary .qmitems-summary-subtotal-value").innerHTML =  
                wetheme.formatMoney(subtotal);
                document.querySelector(".qmitems-order-summary .qmitems-summary-amount-saving").innerHTML = "&minus;"+
                wetheme.formatMoney(bundle_discount);
                if(document.querySelector(".qmitems-order-summary .qmitems-summary-amount-saving-label span")){
                  document.querySelector(".qmitems-order-summary .qmitems-summary-amount-saving-label span").innerHTML = discount_value;
                }
                document.querySelector(".qmitems-order-summary .qmitems-summary-total-value").innerHTML = 
                wetheme.formatMoney(quiz_total);
                setTimeout(() => {
                  curr_par.closest(".quiz-plan-select").classList.remove("show");
                  curr_par.closest(".quiz-plan-select").classList.add("hidden");
                  match_items_par.classList.remove("hidden");
                }, 500);
                setTimeout(() => {
                  match_items_par.classList.add("show");
                  window.scrollTo({
                    top: match_items_par.getBoundingClientRect().top + window.scrollY - 100,
                    behavior: "smooth",
                  });
                  that.updateProgressBar(that);
                  let data_stepname = curr_par.closest(".quiz-plan-select").getAttribute("data-type");
                  let data_stepvalue = curr_par.querySelector(".qpselect-content-item-title").textContent;
                  gtag('event', 'quiz_step', {
                    step_name: data_stepname,
                    step_value: data_stepvalue
                  });
                }, 550);
              }
              that.hideLoader();
            })
          }
        }
      }
      if(e.target.closest(".quiz-flow-engine .qsteps-back-btn")){
        let quiz_parent = e.target.closest(".quiz-flow-engine");
        let all_steps = quiz_parent.querySelectorAll(".quiz-part");
        let active_step = quiz_parent.querySelector(".quiz-part.show");
        let active_index = Array.from(all_steps).indexOf(active_step);
        let prev_step = all_steps[active_index - 1];
        if(prev_step.classList.contains("hide")){
          prev_step = all_steps[active_index - 2];
        }
        setTimeout(() => {
          active_step.classList.add("hidden");
          active_step.classList.remove("show");
          prev_step.classList.remove("hidden");
        }, 200);
        setTimeout(() => {
          prev_step.classList.add("show");
          window.scrollTo({
            top: prev_step.getBoundingClientRect().top + window.scrollY - 100,
            behavior: "smooth",
          });
          that.updateProgressBar(that);
        }, 250);
      }
      if(e.target.closest(".qmitems-summary-checkout")){
        let current_btn = e.target.closest(".qmitems-summary-checkout");
        current_btn.setAttribute('loading',true);
        current_btn.setAttribute('disabled',true);
        let machine_type = that.blends_found[0].machine_name;
        machine_type = machine_type.toLowerCase().replace(/\s+/g, "-");
        if(machine_type == "drip"){
          machine_type = that.blends_found[0].coffee_type;
        }
        let machine_value = machine_type.toLowerCase().replace(/\s+/g, "-");
        let target_bundle = ".bundle-product[data-name="+machine_value+"]";
        let bundle_id = document.querySelector(target_bundle).value;
        let bundle_config = await recharge.bundleData.loadBundleData(bundle_id);
        let itemsToAdd = [];
        let random_num = that.generateRandomCode();
        let freeSubscriptionProdId = current_btn.getAttribute("data-free-subscription-product-id");
        document.querySelectorAll(".qmitems-recom-items .qmitems-recom-item").forEach(function(e,i){
          let item_type = e.getAttribute("data-type");
          let bundle_id_encode = ""+random_num+":"+bundle_id+"";
          let collection_id = "";
          for (const [key, value] of Object.entries(bundle_config.collections)) {
            if(value.handle.includes(item_type)){
              collection_id = value.id;
              break;
            }
          }
          let blend_item = {
            id:e.getAttribute("data-var"),
            quantity:e.getAttribute("data-qty"),
            selling_plan:e.getAttribute("data-plan"),
            properties:{
              "_rc_bundle": bundle_id_encode,
              "_rc_bundle_parent":bundle_config.handle,
              "_rc_bundle_variant":bundle_config.variants[0].id,
              "_rc_bundle_collection_id":collection_id
            }
          }
          itemsToAdd.push(blend_item);
        });
        fetch('/cart.js')
        .then(res => res.json())
        .then(cart => {
          let cart_has_free_item = false;
          cart.items.forEach(item => {
            if(item.variant_id == freeSubscriptionProdId){
              cart_has_free_item = true;
            }
          });
          if(!cart_has_free_item && freeSubscriptionProdId != ""){
            let blend_item = {
              id:freeSubscriptionProdId,
              quantity:"1"
            }
            itemsToAdd.push(blend_item);
            // const discountResponse = fetch(
            //   `/discount/${encodeURIComponent(tayst.subscrCouponCode)}?redirect=/cart`,
            //   {
            //     method: 'GET',
            //     credentials: 'same-origin',
            //     redirect: 'manual'
            //   }
            // );
          }
          fetch(`${window.routes.cart_add_url}.js`, {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'X-Requested-With': 'XMLHttpRequest'
            },
            body: JSON.stringify({ items: itemsToAdd,sections: ['cart-drawer'] }),
          })
          .then(response => response.json())
          .then(response => {
            window.eventBus.emit('update:cart:drawer', response);
            // window.eventBus.emit('open:cart:drawer', { scrollToTop: true });
            location.href = `/checkout?discount=${encodeURIComponent(tayst.subscrCouponCode)}`;
            setTimeout(function(){
              document.querySelector(".quiz-matching-items").classList.add("hidden");
              document.querySelector(".quiz-matching-items").classList.remove("show");
              document.querySelector(".quiz-banner").classList.remove("hidden");
              document.querySelector(".quiz-banner").classList.add("show");
            },1000);
            current_btn.setAttribute('loading',false);
            current_btn.removeAttribute('disabled');
            gtag('event', 'quiz_step', {
              step_name: "quiz_purchase"
            });
          })
          .catch(error => {
            current_btn.setAttribute('loading',false);
            current_btn.removeAttribute('disabled');
            console.log('Error:', error);
          });
        });
      }
    });
  }
  async fetchProductVariants(that,handle){
    let items_json_url = "/products/"+handle+"?view=quiz-cups-item-json";
    const response = await fetch(items_json_url);
    const json_data = await response.text();
    if (json_data && json_data !== "") {
      return JSON.parse(json_data);
    }
    return null;
  }
  collectDataBlocks(elements) {
    const data_blocks = {};
    elements.forEach(step => {
      const key = step.getAttribute("data-type");
      if(step.classList.contains("hide")){
        data_blocks[key] = null;
      }else{
        const active = step.querySelector(".qsteps-content.active");
        data_blocks[key] = active ? active.getAttribute("data-name") : null;
      }
    });
    return data_blocks;
  }
  getNextElement(current, elements, quiz_data, that) {
    let index = Array.from(elements).indexOf(current);
    if (index === -1 || index >= elements.length - 1) {
      that.processPlanSelect(current, elements, quiz_data, that);
      return document.querySelector(".quiz-plan-select");
    }
    let next = elements[index + 1];
    if (index > 0 && next.getAttribute("data-type") === "coffee_type") {
      const machineName = document
        .querySelector(".quiz-steps[data-type=machine_name] .qsteps-content.active")
        ?.getAttribute("data-name")?.toLowerCase();
      const isDrip = machineName?.includes("drip");
      next.classList.toggle("hide", !isDrip);
      if (!isDrip) index++;
    }
    next = elements[index + 1];
    if (index > 0 && next?.getAttribute("data-type") === "roast_preference") {
      const data_blocks = that.collectDataBlocks(elements);
      const validRoasts = new Set(
        quiz_data
          .filter(item =>
            item.machine_name === data_blocks.machine_name &&
            item.total_drinker === data_blocks.total_drinker)
          .map(item => item.roast_preference)
      );
      next.querySelectorAll(".qsteps-content").forEach(step => {
        const isValid = validRoasts.has(step.getAttribute("data-name"));
        step.classList.toggle("hidden", !isValid);
        if (!isValid) step.classList.remove("active");
      });
    }
    if (index < elements.length - 1){
      let next_step_bottom = next.querySelector(".qsteps-bottom-wrap");
      let dynamic_bottom_cont = next_step_bottom?.querySelectorAll(".qsteps-bottom-content-dynamic");
      if(!cn(dynamic_bottom_cont)){
        next.querySelector(".qsteps-bottom-content").innerHTML = next.querySelector(".qsteps-bottom-content-dynamic-default").innerHTML;
        let data_blocks = that.collectDataBlocks(elements);
        let machineLower = data_blocks.machine_name?.toLowerCase();
        for(let i=0;i<dynamic_bottom_cont.length;i++){
          let curr_bottom_index = dynamic_bottom_cont[i].getAttribute("data-step");
          let curr_bottom_machine = dynamic_bottom_cont[i].getAttribute("data-machine");
          if(index + 1 == curr_bottom_index && machineLower == curr_bottom_machine){
            next.querySelector(".qsteps-bottom-content").innerHTML = dynamic_bottom_cont[i].innerHTML;
          }
        }
      }
    }
    if (index < elements.length - 1) return elements[index + 1];
    that.processPlanSelect(current, elements, quiz_data, that);
    return document.querySelector(".quiz-plan-select");
  }
  async processPlanSelect(currentQuiz, quizElements, quiz_data, that) {
    const data_blocks = that.collectDataBlocks(quizElements);
    const machineLower = data_blocks.machine_name?.toLowerCase();
    const step1 = quiz_data.filter(item =>
      item.machine_name === data_blocks.machine_name &&
      item.total_drinker === data_blocks.total_drinker
    );
    that.filterd_step_2 = step1.filter(item =>
      item.roast_preference.includes(data_blocks.roast_preference) &&
      item.coffee_type === data_blocks.coffee_type);
    if (!that.filterd_step_2.length) return;
    const productHandle = (() => {
      if (machineLower.includes("nespresso")) return "capsules-for-nespresso-copy";
      if (machineLower.includes("drip")) {
        const coffeeTypeName = document
          .querySelector(".quiz-steps[data-type=coffee_type] .qsteps-content.active")
          ?.getAttribute("data-name")
          ?.toLowerCase();
        return coffeeTypeName?.includes("ground") ? "ground-coffee-copy" : "whole-bean-2lb-copy";
      }
      return "pods-for-keurig-copy";
    })();
    const prodVars = await that.fetchProductVariants(that, productHandle);
    const seenCups = new Set();
    const cups_array = [];
    for (const item of that.filterd_step_2) {
      if (seenCups.has(item.cups_option)) continue;
      seenCups.add(item.cups_option);
      const match = prodVars.find(v => v.variant_option.split(" ")[0] === item.cups_option);
      if (match) cups_array.push({ ...match, cups: item.cups_option });
    }
    const plan_parent = document.querySelector(".qpselect-content-wrap");
    plan_parent.classList.toggle("center-auto", cups_array.length < 5);
    plan_parent.innerHTML = cups_array.map((v, i) => `
      <div class="qpselect-content grid__item large--one-quarter medium--one-half swiper-slide text-align--center"
        data-cups="${v.cups}" data-animate-order="${i}" data-animate-overflow-item>
        <div class="qpselect-content-item">
          <div class="qpselect-content-item-wrap gutter-bottom--small gutter-top--regular">
            <h3 class="qpselect-content-item-title">${v.variant_title}</h3>
          </div>
          <div class="element--width-100 lazy-image-wrap">
            <div class="responsive-image-wrapper">
              <img loading="lazy" class="theme-img js" alt="${v.cups}"
                width="120" height="120"
                srcset="${v.image} 150w, ${v.image} 140w, ${v.image} 210w"
                sizes="150,140,210" src="${v.image}"/>
            </div>
          </div>
        </div>
      </div>
    `).join("");
    const recomm_message = that.filterd_step_2[0].recommended_text;
    if (recomm_message) {
      document.querySelector(".quiz-plan-select .qpselect-desc").innerHTML =
        recomm_message.replaceAll("\n", "<br/>");
    }
    let bottom_parent = document.querySelector(".quiz-plan-select");
    if(!cn(bottom_parent.querySelector(".qpselect-bottom-bar")?.innerHTML)){
      if(machineLower.includes("drip")){
        bottom_parent.querySelector(".qpselect-bottom-bar").innerHTML = 
        bottom_parent.querySelector(".qpselect-bottom-bar-ground").innerHTML;
        if(!that.filterd_step_2[0].coffee_type.toLowerCase().includes("ground")){
          bottom_parent.querySelector(".qpselect-bottom-bar").innerHTML = 
          bottom_parent.querySelector(".qpselect-bottom-bar-wholebean").innerHTML;
        }
      }else if(machineLower.includes("nespresso")){
        bottom_parent.querySelector(".qpselect-bottom-bar").innerHTML = 
        bottom_parent.querySelector(".qpselect-bottom-bar-nespresso").innerHTML;
      }else{
        bottom_parent.querySelector(".qpselect-bottom-bar").innerHTML = 
        bottom_parent.querySelector(".qpselect-bottom-bar-pods").innerHTML;
      }
    }
  }
  getGroupedProgress(active_index, groups) {
    const totalGroups = groups.length;
    const progressPerGroup = 100 / totalGroups;
    let stepCursor = 0;
    for (let i = 0; i < groups.length; i++) {
      const groupSize = groups[i];
      if (active_index < stepCursor + groupSize) {
        const stepInGroup = active_index - stepCursor + 1;
        return (i * progressPerGroup + (stepInGroup / groupSize) * progressPerGroup);
      }
      stepCursor += groupSize;
    }
    return 100;
  }
  updateProgressBar(that){
    let quiz_parent = document.querySelector(".quiz-flow-engine");
    let all_steps = quiz_parent.querySelectorAll(".quiz-part:not(.quiz-banner):not(.hide)");
    let active_step = quiz_parent.querySelector(".quiz-part:not(.quiz-banner):not(.hide).show");
    let active_index = Array.from(all_steps).indexOf(active_step);
    let groups = all_steps.length == 5 ? [3, 1, 1] : [all_steps.length];
    let progress = that.getGroupedProgress(active_index, groups);
    let progress_fill = quiz_parent.querySelector(".quiz-header-progress-line");
    progress_fill.style.width = progress + "%";
    quiz_parent.querySelector(".quiz-header-progress-bar").classList.remove("non-visible");
    if(progress > 90){
      quiz_parent.querySelector(".quiz-header-progress-bar").classList.add("non-visible");
    }
  }
  decodeHTML(str) {
    const temp = document.createElement("textarea");
    temp.innerHTML = str;
    return temp.value;
  }
  generateRandomCode() {
    const chars = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let code = '';
    for (let i = 0; i < 9; i++) {
      const randomIndex = Math.floor(Math.random() * chars.length);
      code += chars[randomIndex];
    }
    return code;
  }
  showLoader(show_text=true,bg_blur=false){
    document.querySelector("#page-loader").classList.add('active');
    if(!show_text){
      document.querySelector("#page-loader").classList.add('hide-text');
    }
    if(bg_blur){
      document.querySelector("#page-loader").classList.add('bg-blur');
    }
  }
  hideLoader(){
    document.querySelector("#page-loader").classList.remove('active','hide-text','bg-blur');
  }
}
new QuizCheckout();